import React from 'react';
import { convertDate } from 'src/utils/common';
import { NoRecords } from 'src/reusable';
import { CDataTable } from '@coreui/react';
import { isPermission } from 'src/utils/common';
const CoffApprovalList = props => {
  const { data, type, renderDataStatus, renderDataActionBtn } = props;
  const fields = [
    {
      label: 'S.No.',
      key: 's_no',
      sorter: false,
      filter: true,
    },
    {
      label: 'Employee ID',
      key: 'emp_id',
      sorter: false,
      filter: true,
    },
    {
      label: 'Employee Name',
      key: 'employee_name',
      sorter: true,
      filter: true,
    },
    {
      label: 'Comp Off Date',
      key: 'compOff_date',
      sorter: false,
      filter: false,
    },
    {
      label: 'Comp Off Status',
      key: 'no_of_days',
      sorter: false,
      filter: false,
    },
    {
      label: 'Comp Off Reason',
      key: 'reason',
      sorter: false,
      filter: false,
    },
    {
      label: 'Approval Status',
      key: 'status',
      sorter: false,
      filter: true,
    },
    {
      label: 'Created Date',
      key: 'created_at',
      sorter: false,
      filter: false,
    },
    {
      label: '',
      key: 'action',
      sorter: true,
      filter: true,
    },
  ];

  return (
    <CDataTable
      items={data}
      fields={fields}
      tableFilter={{label: 'Filter:', placeholder: 'Search'}}
      itemsPerPageSelect
      itemsPerPage={10}
      hover
      // sorter
      pagination
      scopedSlots={{
        s_no: (item, index) => (
          <td>
            <b>{index + 1}</b>
          </td>
        ),
        status: item => <td>{renderDataStatus(item, type)}</td>,
        compOff_date: item => (
          <td>{convertDate(item.compOff_date, 'DD-MM-YYYY')}</td>
        ),
        created_at: item => (
          <td>{convertDate(item.created_at, 'DD-MM-YYYY')}</td>
        ),
        action: item => (
          <td>
            {isPermission('approve_reject_leave_request') && (
              <>{renderDataActionBtn(item, type)}</>
            )}
          </td>
        ),
      }}
    />
  );
};

export default CoffApprovalList;
